import React, { useContext } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';
import AdminLayout from './layout/AdminLayout';
import AuthLayout from './layout/AuthLayout';
import Login from './views/login/Login';
import Forbidden from './error/Forbidden';
import NotFound from './error/NotFound';
import productRoutes from './views/product/routes';
import brandRoutes from './views/brand/routes';
import categoryRoutes from './views/category/routes';
import userRoutes from './views/user/routes';
import storeRoutes from './views/store/routes';
import transactionRoutes from './views/transaction/routes';
import customerRoutes from './views/customer/routes';
import employeeRoutes from './views/employee/routes';
import vendorRoutes from './views/vendor/routes';
import orderRoutes from './views/order/routes';
import warehouseRoutes from './views/warehouse/routes';
import transferRoutes from './views/transfer/routes';
import dashboardRoutes from './views/dashboard/routes';
import { AuthContext } from './contexts/AuthContext';

import dayjs from 'dayjs';

export default function Router() {

    const { user } = useContext(AuthContext);
    const isAuth = !!JSON.parse(user)

    // console.log(dayjs().toISOString());

    return useRoutes([
        {
            path: 'admin',
            element: <AdminLayout />,
            children: [
                ...productRoutes,
                ...brandRoutes,
                ...categoryRoutes,
                ...userRoutes,
                ...storeRoutes,
                ...transactionRoutes,
                ...customerRoutes,
                ...employeeRoutes,
                ...vendorRoutes,
                ...warehouseRoutes,
                ...orderRoutes,
                ...transferRoutes,
                ...dashboardRoutes
            ]
        },
        {
            path: '/',
            element: <AuthLayout />,
            children: [
                {
                    path: 'login',
                    element: <Login />
                },
                {
                    path: '/',
                    element: isAuth ? <Navigate to={`/admin/dashboard?start_date=${dayjs().toISOString()}&end_date=${dayjs().toISOString()}`} replace={true} /> : <Navigate to="/login" replace={true} />
                },
            ]
        },
        { path: '/forbidden', element: <Forbidden /> },
        { path: '*', element: <NotFound /> }
    ])
}